// post-t7-2a (bloque E, diseno 2.5 y 3.1): las escenas "en vivo" de la portada, portadas de la
// maqueta (portada_maqueta_v6.html: Escena, alAparecer, guiones y unaVez) como RESULTADO.
//
// Como funciona, en una frase: el HTML que pinta React ya trae el ESTADO FINAL de cada dibujo,
// con todo su texto (asi lo leen los robots, el pre-pintado y quien tiene "reducir movimiento");
// cuando se puede mover, cada dibujo corre su guion EN BUCLE mientras esta a la vista (35 por
// ciento o mas de el) y se detiene al salir. El guion empieza siempre por poner su estado
// inicial, asi que puede cortarse en cualquier punto. Ninguno espera a otro (regla 6 de Carlos).
// Lo que corre una sola vez (los taches del problema, Analiticas y la tabla de comparacion)
// entra cuando ELLO aparece; donde hay renglones, cada renglon cuando EL aparece.
//
// Este archivo no sabe de React: trabaja sobre el DOM que la portada ya pinto. Lo monta
// `montarEscenas(raiz)` y lo desmonta la funcion que devuelve.

const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));

const ALTO = {};

// Una escena: su guion corre en bucle entre arrancar() y parar(). Cada espera revisa su turno;
// si la escena se paro (o se volvio a arrancar), la espera se rompe con ALTO y el bucle termina.
export function crearEscena(raiz, guion) {
  let turno = 0;
  let corriendo = false;
  const ctx = {
    raiz,
    dormir(ms) {
      const mio = turno;
      return new Promise((res, rej) => {
        setTimeout(() => { if (corriendo && mio === turno) res(); else rej(ALTO); }, ms);
      });
    },
    animar(ms, fn) {
      const mio = turno;
      return new Promise((res, rej) => {
        let t0 = null;
        const paso = (t) => {
          if (!corriendo || mio !== turno) { rej(ALTO); return; }
          if (t0 === null) t0 = t;
          const p = Math.min(1, (t - t0) / ms);
          fn(p);
          if (p < 1) requestAnimationFrame(paso); else res();
        };
        requestAnimationFrame(paso);
      });
    },
  };
  const ciclo = async () => {
    const mio = turno;
    try {
      while (corriendo && mio === turno) {
        await guion(ctx);
      }
    } catch (e) {
      if (e !== ALTO) throw e;
    }
  };
  return {
    arrancar() { if (corriendo) return; corriendo = true; turno += 1; raiz.classList.add('viva'); ciclo(); },
    parar() { corriendo = false; turno += 1; },
    get corriendo() { return corriendo; },
  };
}

const FLECHA = '<svg viewBox="0 0 24 24"><path d="M5 3l14 8.6-6.3 1.6L9.7 19.5z" fill="#fff" stroke="#0e0e0e" stroke-width="1.3" stroke-linejoin="round"/></svg>';
export const PALOMA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
export const TACHE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

function cursorDe(viz) {
  let c = $('.cur', viz);
  if (!c) {
    c = document.createElement('span');
    c.className = 'cur';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = FLECHA;
    viz.appendChild(c);
  }
  return c;
}
function puntoDe(viz, el, fx, fy) {
  const a = viz.getBoundingClientRect();
  const b = el.getBoundingClientRect();
  return [b.left - a.left + b.width * (fx == null ? 0.5 : fx), b.top - a.top + b.height * (fy == null ? 0.6 : fy)];
}
function ponCursor(c, viz, fx, fy) {
  const p = puntoDe(viz, viz, fx, fy);
  c.style.transitionDuration = '0ms, 0ms';
  c.style.opacity = '0';
  c.style.transform = `translate(${p[0]}px,${p[1]}px)`;
}
async function clic(ctx, c, el) {
  c.classList.add('pr'); el.classList.add('pr');
  await ctx.dormir(130);
  c.classList.remove('pr'); el.classList.remove('pr');
}
// vuelve a disparar una animacion de CSS: quita la clase, fuerza el calculo y la pone otra vez
function golpe(el, clase) {
  el.classList.remove(clase);
  el.getBoundingClientRect();
  el.classList.add(clase);
}
function cuentaDe(el, ini, fin, ms, suf) {
  let t0 = null;
  const s = suf || '';
  const paso = (t) => {
    if (t0 === null) t0 = t;
    const p = Math.min(1, (t - t0) / ms);
    const e = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.round(ini + (fin - ini) * e) + s;
    if (p < 1) requestAnimationFrame(paso);
  };
  requestAnimationFrame(paso);
}

// post-t7-2c (bloque B, anexo B.3): los tiempos de a3 y a4, en milisegundos. Son los MISMOS que el
// guion incrustado de las paginas de profesores (alli van sin export); una prueba compara los dos.
export const TIEMPOS_A3 = { espera: 700, pregunta: 900, resultado: 450, pausa: 2600, cierre: 300 };
export const TIEMPOS_A4 = { espera: 500, renglon: 1050, eco1: 320, eco2: 750, eco3: 250, pausa: 3000, cierre: 320 };

export const GUIONES = {
  // Estudio Adaptativo 1: una sesion de ejemplo; las barras crecen en la proporcion de cada tema. Sin numeros a la vista.
  async a1(c) {
    const filas = $$('.fr', c.raiz);
    const n = [0, 0, 0, 0];
    const pinta = (i, vivo) => {
      $('.fr-t i', filas[i]).style.width = `${n[i] * 10}%`;
      if (vivo) golpe($('.sq', filas[i]), 'pop');
    };
    filas.forEach((_f, i) => pinta(i, false));
    await c.dormir(700);
    const orden = [0, 1, 0, 2, 0, 1, 0, 0, 1, 2, 0, 1, 0, 3, 0, 1, 0, 2, 1, 0];
    for (let k = 0; k < orden.length; k += 1) {
      n[orden[k]] += 1;
      pinta(orden[k], true);
      await c.dormir(430);
    }
    await c.dormir(3000);
  },
  // Estudio Adaptativo 2: los 14 dias corren; cada repaso devuelve la linea arriba y la hace caer mas lento
  async a2(c) {
    const svg = $('.crv', c.raiz);
    const rect = $('.crv-c', svg);
    const m = $('.crv-m', svg);
    const pts = JSON.parse(svg.getAttribute('data-pts'));
    const x0 = +svg.getAttribute('data-x0');
    const w = +svg.getAttribute('data-w');
    const rev = $$('.crv-p circle', svg);
    const ticks = $$('.crv-ax > span', c.raiz);
    const dRev = [1, 3, 7];
    const dTick = [1, 3, 7, 14];
    const en = (x) => {
      let j = 0;
      for (let i = 0; i < pts.length; i += 1) { if (pts[i][0] <= x + 0.01) j = i; else break; }
      return pts[j];
    };
    svg.classList.remove('fd');
    rect.setAttribute('width', x0);
    rev.forEach((r) => r.classList.remove('on'));
    ticks.forEach((s) => s.classList.remove('on'));
    m.setAttribute('cx', pts[0][0]); m.setAttribute('cy', pts[0][1]);
    await c.dormir(600);
    await c.animar(5600, (p) => {
      const x = x0 + p * w;
      const dia = p * 14;
      rect.setAttribute('width', x); m.setAttribute('cx', x); m.setAttribute('cy', en(x)[1]);
      rev.forEach((r, i) => { if (dia >= dRev[i]) r.classList.add('on'); });
      ticks.forEach((s, i) => { if (dia >= dTick[i] - 0.05) s.classList.add('on'); });
    });
    await c.dormir(2800);
    svg.classList.add('fd');
    ticks.forEach((s) => s.classList.remove('on'));
    await c.dormir(450);
  },
  // Estudio Adaptativo 3: seis preguntas seguidas de un tema. Cada una entra, se contesta y deja su resultado;
  // si va acertando la que sigue sale mas arriba, y despues de fallar la que sigue baja. Sin numeros del motor.
  async a3(c) {
    const v = c.raiz;
    const celdas = $$('.sx li', v);
    const sube = $('.st-r .sube', v);
    const baja = $('.st-r .baja', v);
    if (!v.lvFin) v.lvFin = celdas.map((li) => (li.classList.contains('ko') ? 'ko' : (li.classList.contains('ok') ? 'ok' : 'now')));
    const fin = v.lvFin;
    const marca = (li, r) => {
      $('.sx-r', li).innerHTML = r === 'ok' ? PALOMA : (r === 'ko' ? TACHE : '');
      li.classList.remove('ok', 'ko', 'now');
      li.classList.add(r);
    };
    celdas.forEach((li) => { li.classList.remove('in', 'ok', 'ko', 'now'); $('.sx-r', li).innerHTML = ''; });
    sube.classList.remove('on'); baja.classList.remove('on');
    await c.dormir(TIEMPOS_A3.espera);
    let antes = 0;
    for (let k = 0; k < celdas.length; k += 1) {
      const li = celdas[k];
      const n = +li.getAttribute('data-n');
      marca(li, 'now'); li.classList.add('in');
      if (antes && n > antes) sube.classList.add('on');
      if (antes && n < antes) baja.classList.add('on');
      await c.dormir(TIEMPOS_A3.pregunta);
      sube.classList.remove('on'); baja.classList.remove('on');
      if (fin[k] !== 'now') {
        marca(li, fin[k]);
        await c.dormir(TIEMPOS_A3.resultado);
      }
      antes = n;
    }
    await c.dormir(TIEMPOS_A3.pausa);
    celdas.forEach((li) => li.classList.remove('in'));
    await c.dormir(TIEMPOS_A3.cierre);
  },
  // Estudio Adaptativo 4: una sesion de seis preguntas. Cada una entra con su tema, como va el alumno en el y por que
  // sale ahora. Cuando regresa un tema que ya salio, se encienden juntas sus apariciones: se ve que vuelve a proposito.
  async a4(c) {
    const filas = $$('.mz li', c.raiz);
    filas.forEach((li) => { li.classList.add('oc'); li.classList.remove('eco'); });
    await c.dormir(TIEMPOS_A4.espera);
    for (let k = 0; k < filas.length; k += 1) {
      const li = filas[k];
      const tema = li.getAttribute('data-t');
      const juntas = filas.slice(0, k).filter((x) => x.getAttribute('data-t') === tema);
      li.classList.remove('oc');
      if (juntas.length) {
        const todas = juntas.concat([li]);
        await c.dormir(TIEMPOS_A4.eco1);
        todas.forEach((x) => x.classList.add('eco'));
        await c.dormir(TIEMPOS_A4.eco2);
        todas.forEach((x) => x.classList.remove('eco'));
        await c.dormir(TIEMPOS_A4.eco3);
      } else {
        await c.dormir(TIEMPOS_A4.renglon);
      }
    }
    await c.dormir(TIEMPOS_A4.pausa);
    filas.forEach((li) => li.classList.add('oc'));
    await c.dormir(TIEMPOS_A4.cierre);
  },
  // La tarjeta de arriba: el puntero cruza A, llega a B, la elige mal y sale el porque
  async hq(c) {
    const v = c.raiz;
    const ops = $$('.lv-opt', v);
    const ex = $('.lv-explain', v);
    const cur = cursorDe(v);
    ops.forEach((o) => { o.className = 'lv-opt'; });
    ex.classList.remove('show');
    ponCursor(cur, v, 0.09, 0.1);
    await c.dormir(800);
    cur.style.transitionDuration = '0ms, 300ms'; cur.style.opacity = '1';
    await c.dormir(120);
    const p = puntoDe(v, ops[1], 0.5, 0.5);
    cur.style.transitionDuration = '500ms, 300ms';
    cur.style.transform = `translate(${p[0]}px,${p[1]}px)`;
    await c.dormir(190); ops[0].classList.add('hot');
    await c.dormir(140); ops[0].classList.remove('hot');
    await c.dormir(170); ops[1].classList.add('hot');
    await c.dormir(520);
    await clic(c, cur, ops[1]);
    ops.forEach((o) => { o.className = `lv-opt ${o.getAttribute('data-fin')}`; });
    await c.dormir(260); cur.style.opacity = '0';
    await c.dormir(300); ex.classList.add('show');
    await c.dormir(4900);
  },
  // Como funciona: TRES escenas, una por tarjeta, de 6.2 s cada una: si aparecen juntas, siguen juntas.
  // post-t7-2c (bloque B, anexo B.5): el numero de la tarjeta se enciende (on) al arrancar la escena y
  // se queda encendido mientras corre; ya no pasa a done al final de cada vuelta.
  async como1(c) {
    const v = c.raiz;
    const f = $('.up-f', v);
    const bar = $('.up-bar i', v);
    const okk = $('.up-ok', v);
    const zona = $('.up-z', v);
    v.classList.add('on');
    f.classList.add('oc'); okk.classList.add('oc'); zona.classList.remove('on');
    bar.style.transitionDuration = '0ms'; bar.style.width = '0%';
    await c.dormir(450);
    zona.classList.add('on');
    await c.dormir(400); f.classList.remove('oc');
    await c.dormir(450); bar.style.transitionDuration = ''; bar.style.width = '100%';
    await c.dormir(1400); okk.classList.remove('oc'); golpe(okk, 'pop'); zona.classList.remove('on');
    await c.dormir(3500);
  },
  async como2(c) {
    const v = c.raiz;
    const nq = $('[data-n="q"]', v);
    const nf = $('[data-n="f"]', v);
    const filas = $$('.gen-l li', v);
    v.classList.add('on');
    nq.textContent = '0'; nf.textContent = '0';
    filas.forEach((l) => l.classList.add('oc'));
    await c.dormir(450);
    cuentaDe(nq, 0, +nq.getAttribute('data-v'), 900);
    cuentaDe(nf, 0, +nf.getAttribute('data-v'), 900);
    for (let k = 0; k < filas.length; k += 1) {
      await c.dormir(340);
      filas[k].classList.remove('oc');
    }
    await c.dormir(700);
    await c.dormir(4030);
  },
  async como3(c) {
    const v = c.raiz;
    const cols = $$('.ses-c i', v);
    const sn = $('.ses-n b', v);
    const alt = cols.map((i) => +i.getAttribute('data-v'));
    v.classList.add('on');
    cols.forEach((i) => { i.style.transitionDuration = '0ms'; i.style.height = '0%'; });
    sn.textContent = '0';
    await c.dormir(450);
    for (let k = 0; k < cols.length; k += 1) {
      cols[k].style.transitionDuration = ''; cols[k].style.height = `${alt[k]}%`;
      cuentaDe(sn, k ? alt[k - 1] : 0, alt[k], 650);
      await c.dormir(900);
    }
    await c.dormir(3050);
  },
  // Lo que obtienes 1: la opcion elegida sale mal, se marca la correcta y aparece el porque
  async c1(c) {
    const v = c.raiz;
    const mal = $('[data-r="no"]', v);
    const bien = $('[data-r="si"]', v);
    const e = $('.mq-e', v);
    mal.classList.remove('no'); bien.classList.remove('si'); e.classList.add('oc');
    await c.dormir(1000); mal.classList.add('no');
    await c.dormir(520); bien.classList.add('si');
    await c.dormir(480); e.classList.remove('oc');
    await c.dormir(3800);
  },
  // Lo que obtienes 2: la flashcard se voltea y pasa a la siguiente
  async c2(c) {
    const v = c.raiz;
    const fc = $('.fc', v);
    const w = $('.fc-w', v);
    const card = $('.fc-card', v);
    const n = $('.fc-n b', v);
    const sinTransicion = (el, fn) => { el.style.transitionDuration = '0ms'; fn(); el.getBoundingClientRect(); el.style.transitionDuration = ''; };
    sinTransicion(card, () => card.classList.remove('flip'));
    sinTransicion(w, () => w.classList.remove('sale', 'entra'));
    for (let k = 1; k <= 3; k += 1) {
      n.textContent = k; fc.setAttribute('data-k', k);
      await c.dormir(1900);
      card.classList.add('flip');
      await c.dormir(3600);
      w.classList.add('sale');
      await c.dormir(300);
      sinTransicion(card, () => card.classList.remove('flip'));
      sinTransicion(w, () => { w.classList.remove('sale'); w.classList.add('entra'); });
      w.classList.remove('entra');
      await c.dormir(350);
    }
    fc.setAttribute('data-k', 1); n.textContent = 1;
  },
  // Lo que obtienes 3: StudyBuddy decide el tema, la pregunta y la dificultad, y sale la siguiente pregunta
  async c3(c) {
    const v = c.raiz;
    const cs = $$('.nx-c', v);
    const q = $('.nx-q', v);
    cs.forEach((x) => { x.classList.remove('on'); x.classList.add('oc'); });
    q.classList.add('oc');
    await c.dormir(700);
    for (let k = 0; k < cs.length; k += 1) {
      if (k) cs[k - 1].classList.remove('on');
      cs[k].classList.remove('oc'); cs[k].classList.add('on');
      await c.dormir(900);
    }
    cs[cs.length - 1].classList.remove('on'); q.classList.remove('oc');
    await c.dormir(4200);
  },
  // Lo que obtienes 4: el dominio de cada tema se llena
  async c4(c) {
    const v = c.raiz;
    const fs = $$('.tp-t i', v);
    const ns = $$('.tp-r b', v);
    const vals = fs.map((f) => +f.getAttribute('data-v'));
    fs.forEach((f) => { f.style.transitionDuration = '0ms'; f.style.width = '0%'; });
    ns.forEach((x) => { x.textContent = '0%'; });
    await c.dormir(600);
    for (let k = 0; k < fs.length; k += 1) {
      fs[k].style.transitionDuration = ''; fs[k].style.width = `${vals[k]}%`;
      cuentaDe(ns[k], 0, vals[k], 850, '%');
      await c.dormir(380);
    }
    await c.dormir(4400);
  },
};

// Cada cosa se anima cuando ELLA aparece en la pantalla; ninguna espera a que termine otra.
// Las que aparecen a la vez entran casi juntas, en su orden, con un respiro de `paso` ms.
// Devuelve el observador (para desconectarlo al desmontar).
export function alAparecer(items, paso, fn) {
  if (!items.length) return null;
  const io = new IntersectionObserver((entradas) => {
    let j = 0;
    entradas.forEach((en) => {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      const el = en.target;
      const d = j * paso;
      j += 1;
      if (d) setTimeout(() => fn(el), d); else fn(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.3 });
  items.forEach((el) => io.observe(el));
  return io;
}

// Lo que corre UNA sola vez, al aparecer. Donde hay varios renglones, cada renglon entra cuando EL aparece.
export const UNA_VEZ = {
  dolor: {
    prep: (el) => $$('.lv-pain', el).forEach((p) => p.classList.add('oc2')),
    cosas: (el) => $$('.lv-pain', el),
    paso: 120,
    una: (p) => { p.classList.remove('oc2'); golpe($('.lv-x', p), 'pop'); },
  },
  ana: {
    prep: (el) => {
      $('.ana-n', el).textContent = '0';
      $$('.lv-readiness-bar-fill,.lv-tc-fill', el).forEach((b) => { b.style.transitionDuration = '0ms'; b.style.width = '0%'; });
    },
    va: (el) => {
      const n = $('.ana-n', el);
      const fin = +n.getAttribute('data-v');
      setTimeout(() => {
        cuentaDe(n, 0, fin, 800);
        $$('.lv-readiness-bar-fill,.lv-tc-fill', el).forEach((b) => { b.style.transitionDuration = ''; b.style.width = `${b.getAttribute('data-v')}%`; });
      }, 350);
    },
  },
  cmp: {
    prep: (el) => $$('.lv-crow', el).forEach((r) => r.classList.add('oc2')),
    cosas: (el) => $$('.lv-crow', el),
    paso: 140,
    una: (r) => {
      r.classList.remove('oc2');
      if (r.classList.contains('hl')) {
        setTimeout(() => { r.classList.add('luz'); setTimeout(() => r.classList.remove('luz'), 1400); }, 520);
      }
    },
  },
};

// Con mouse: la cuadricula del fondo se ilumina alrededor del cursor y las celdas por donde pasa
// se encienden y se apagan. Devuelve la funcion que lo quita.
function montarLuz(raiz, luz) {
  const CEL = 56;
  const MITAD = 280;
  const celdas = [];
  let turnoC = 0;
  let ult = '';
  let mx = 0; let my = 0; let tx = 0; let ty = 0; let cx = -1; let cy = -1;
  let andando = false; let dentro = false; let vivo = true;
  for (let q = 0; q < 16; q += 1) {
    const cel = document.createElement('i');
    cel.className = 'lv-gc';
    cel.setAttribute('aria-hidden', 'true');
    raiz.insertBefore(cel, raiz.firstChild);
    celdas.push(cel);
  }
  const cuadro = () => {
    if (!vivo) return;
    mx += (tx - mx) * 0.22; my += (ty - my) * 0.22;
    const rx = Math.round(mx); const ry = Math.round(my);
    luz.style.transform = `translate3d(${rx}px,${ry}px,0)`;
    luz.style.backgroundPosition = `${MITAD - rx}px ${MITAD - ry}px`;
    if (Math.abs(tx - mx) + Math.abs(ty - my) > 0.4) requestAnimationFrame(cuadro); else andando = false;
  };
  const mover = () => {
    const r = raiz.getBoundingClientRect();
    tx = cx - r.left; ty = cy - r.top;
    if (!dentro) { dentro = true; mx = tx; my = ty; luz.style.opacity = '1'; }
    const a = Math.floor(tx / CEL); const b = Math.floor(ty / CEL); const k = `${a}:${b}`;
    if (k !== ult && ty >= 0) {
      ult = k;
      const el = celdas[turnoC % celdas.length];
      turnoC += 1;
      el.style.transform = `translate3d(${a * CEL + 1}px,${b * CEL + 1}px,0)`;
      golpe(el, 'on');
    }
    if (!andando) { andando = true; requestAnimationFrame(cuadro); }
  };
  const alMover = (e) => {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    cx = e.clientX; cy = e.clientY;
    mover();
  };
  const alBajar = () => { if (dentro && cx >= 0) mover(); };
  const alSalir = () => { dentro = false; luz.style.opacity = '0'; };
  window.addEventListener('pointermove', alMover, { passive: true });
  window.addEventListener('scroll', alBajar, { passive: true });
  document.documentElement.addEventListener('pointerleave', alSalir);
  return () => {
    vivo = false;
    window.removeEventListener('pointermove', alMover);
    window.removeEventListener('scroll', alBajar);
    document.documentElement.removeEventListener('pointerleave', alSalir);
    celdas.forEach((c) => c.remove());
  };
}

const coincide = (q) => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(q).matches;

// Monta todo lo que se mueve dentro de `raiz` (la portada). Quien llama ya decidio que se puede
// mover (sin "reducir movimiento", fuera del pre-pintado y con IntersectionObserver).
export function montarEscenas(raiz) {
  const quitar = [];
  const escenas = [];

  // aparecer al bajar: las tarjetas entran escalonadas (80 ms), y se sueltan al terminar
  const ioRv = new IntersectionObserver((entradas) => {
    let j = 0;
    entradas.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target;
      const d = Math.min(j, 5) * 80;
      j += 1;
      el.style.transitionDelay = `${d}ms`;
      el.classList.add('in');
      ioRv.unobserve(el);
      setTimeout(() => { el.style.transitionDelay = ''; el.classList.remove('rv', 'in'); }, d + 2600);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
  $$('.rv', raiz).forEach((el) => ioRv.observe(el));
  quitar.push(() => ioRv.disconnect());

  // las escenas en bucle: arrancan con 35 por ciento a la vista y se detienen al salir
  const ioE = new IntersectionObserver((entradas) => {
    entradas.forEach((en) => {
      const e = en.target.lvEscena;
      if (!e) return;
      if (en.intersectionRatio >= 0.35) e.arrancar();
      else if (!en.isIntersecting || en.intersectionRatio <= 0.01) e.parar();
    });
  }, { threshold: [0, 0.35] });
  $$('[data-esc]', raiz).forEach((el) => {
    const g = GUIONES[el.getAttribute('data-esc')];
    if (!g) return;
    const e = crearEscena(el, g);
    el.lvEscena = e;
    escenas.push(e);
    ioE.observe(el);
  });
  quitar.push(() => { ioE.disconnect(); escenas.forEach((e) => e.parar()); });

  // lo que corre una vez
  const ioU = new IntersectionObserver((entradas) => {
    entradas.forEach((en) => {
      if (!en.isIntersecting) return;
      ioU.unobserve(en.target);
      const u = UNA_VEZ[en.target.getAttribute('data-once')];
      if (u) u.va(en.target);
    });
  }, { threshold: 0.18 });
  $$('[data-once]', raiz).forEach((el) => {
    const u = UNA_VEZ[el.getAttribute('data-once')];
    if (!u) return;
    u.prep(el);
    if (u.cosas) {
      const io = alAparecer(u.cosas(el), u.paso, u.una);
      if (io) quitar.push(() => io.disconnect());
    } else {
      ioU.observe(el);
    }
  });
  quitar.push(() => ioU.disconnect());

  // con puntero: la linea de luz del borde de cada tarjeta sigue al cursor (el relleno no cambia)
  if (coincide('(hover: hover)')) {
    $$('.pc', raiz).forEach((card) => {
      const f = (e) => {
        const r = card.getBoundingClientRect();
        card.style.setProperty('--mx', `${e.clientX - r.left}px`);
        card.style.setProperty('--my', `${e.clientY - r.top}px`);
      };
      card.addEventListener('pointermove', f);
      quitar.push(() => card.removeEventListener('pointermove', f));
    });
  }

  // el fondo: solo con mouse
  const luz = $('.lv-gl', raiz);
  if (luz && coincide('(hover: hover) and (pointer: fine)')) quitar.push(montarLuz(raiz, luz));

  return () => quitar.forEach((f) => f());
}
